"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logReporter = void 0;
var nucleus_logging_1 = require("@cvent/nucleus-logging");
var transformers_1 = require("../transformers");
var LOG = new nucleus_logging_1.Logger('LogReporter');
/**
 * The logReporter is useful in testing / monitoring metrics that are tracked during development
 *
 * @param type
 * @param data
 * @param options
 * @param callback
 */
var logReporter = function (type, data, options, callback) {
    // Check for fieldMappings and apply transformation if any
    var finalData = (0, transformers_1.transformPropertiesWithFieldMappings)(data, options);
    switch (type) {
        case 'page_load': {
            LOG.debug("Event ".concat(type, " for ").concat(finalData.pathname, " finished in ").concat(finalData.duration, "ms [").concat(finalData.type, "] >>>> "), data);
            break;
        }
        default:
            var durationText = (finalData === null || finalData === void 0 ? void 0 : finalData.duration) ? "in ".concat(finalData.duration, "ms") : '';
            LOG.debug("Event ".concat(type, " [").concat(finalData.result, "] finished ").concat(durationText, " >>>> "), finalData);
            break;
    }
    if (callback)
        callback('logReporter', { id: type, data: finalData, options: options });
};
exports.logReporter = logReporter;
